import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Img from 'react-image';
import P from '../typography/P';

const Header = styled.h2`
  margin: 9px 0 5px 0;
  color: ${props => props.theme.color.secondary};
  font-size: 16px;
  font-family: ${props => props.theme.font.metaOt};
  font-weight: ${props => props.theme.fontWeight.bold};
  line-height: 1.5;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const Image = styled(Img)`
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  height: 204px;
  cursor: pointer;

  div {
    transition: all 0.2s ease-in-out;
    transform: scale(1);
  }

  &:hover {
    div {
      transform: scale(1.25);
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media ${p => p.theme.media.largePhone} {
    margin-bottom: 48px;
  }
`;

const PlayButton = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  height: 100%;
  left: calc(50% - 24px);
`;

const Video = ({ description, heading, imageUrl, showVideo }) => (
  <Wrapper>
    {imageUrl && (
      <ImageWrapper onClick={showVideo}>
        <PlayButton>
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="34">
            <path
              fill="#CE1312"
              fillRule="evenodd"
              stroke="#FFF"
              strokeWidth="1.25px"
              d="M19.04 23.27V9.69l12.97 6.81-12.97 6.77zM47.52 7.33s-.47-3.33-1.9-4.8C43.78.62 41.73.6 40.8.5 34.1 0 24.01 0 24.01 0H24S13.9 0 7.19.49C6.27.6 4.22.6 2.4 2.54.95 4 .48 7.34.48 7.34S0 11.23 0 15.15v3.67c0 3.9.48 7.82.48 7.82s.47 3.33 1.9 4.8c1.83 1.92 4.23 1.86 5.3 2.06C11.52 33.9 24 34 24 34s10.09-.02 16.8-.5c.94-.12 2.99-.13 4.81-2.05 1.44-1.47 1.91-4.8 1.91-4.8s.48-3.91.48-7.82v-3.67c0-3.91-.48-7.83-.48-7.83z"
            />
          </svg>
        </PlayButton>
        <Image src={imageUrl} alt={heading} />
      </ImageWrapper>
    )}
    {heading && <Header>{heading}</Header>}
    {description && <P>{description}</P>}
  </Wrapper>
);

Video.propTypes = {
  description: PropTypes.string,
  heading: PropTypes.string,
  imageUrl: PropTypes.array,
  showVideo: PropTypes.func.isRequired
};

export default Video;
